<template>
<div class="makeMoney">
    <div class="makeMoney-main">

        <div class="nav clearfix">
            <router-link to='/home'>
                <img class="navBack pull-left" src="../../../static/images/shootShop/back.png" alt="">
            </router-link>
            <h2 class="navTitle pull-left">拍店赚钱</h2>
            <h5 class="record">
                <router-link to='/record'>
                    拍店记录
                </router-link>
            </h5>
        </div>
        
        <div class="makeMoney-center">
            <div class="imgBanner">
                <router-link to='/rule'>
                    <img src="../../../static/images/shootShop/imgBanner.png">
                </router-link>
            </div>
            <div class="makeMoney-center-Dl">
                <dl class="dl1 clearfix">
                    <dt>
                        <img src="../../../static/images/shootShop/tel.png">
                        <span>店主电话</span>
                    </dt>
                    <dd>
                        <input type="tel" name="" v-model="shopkeeperTel" placeholder="请输入店主电话" maxlength="12" v-if="this.jnCityId == '370100'">
                        <input type="tel" name="" v-model="shopkeeperTel" placeholder="请输入店主电话" maxlength="11" v-else>
                    </dd>
                    <div v-if="showRepeat">
                        <img src="../../../static/images/shootShop/error.png">
                        <span>已有该铺，请重新上传</span>
                    </div>
                </dl>
                <dl class="dl2 clearfix">
                    <dt>
                        <img src="../../../static/images/shootShop/local.png">
                        <span>定位</span>
                    </dt>
                    <dd>
                        <span>{{addressStr}}</span>
                        <img src="../../../static/images/shootShop/refresh.png" @click="refreshMap()">
                    </dd>
                </dl>
                <span v-if="iswx"><font size="1" color="red">温馨提示：如定位不准确，请点击右上角（···）选择在浏览器中打开该页面</font></span>
            </div>
        </div>
        <div class="uploadPic">
            <dl class="clearfix">
                <dt>上传图片</dt>
                <dd>
                    <router-link to='/sample'>
                        <span>拍店示例</span>
                    </router-link>
                    <img src="../../../static/images/shootShop/exampleImg.png">
                </dd>
            </dl>
            <ul class="clearfix uploadPicUl">
                <li>
                    <img :src="img1">
                    <input type="file" accept="image/*" name="file_head" @change="imgFun1($event)"/>
                </li>
                <li>
                    <img :src="img2">
                    <input type="file" accept="image/*" name="file_head" @change="imgFun2($event)"/>
                </li>
                <li>
                    <img :src="img3">
                    <input type="file" accept="image/*" name="file_head" @change="imgFun3($event)"/>
                </li>
                <li>
                    <img :src="img4">
                    <input type="file" accept="image/*" name="file_head" @change="imgFun4($event)"/>
                </li>
                <div v-if="showMore">
                    <li>
                        <img :src="img5">
                        <input type="file" accept="image/*" name="file_head" @change="imgFun5($event)"/>
                    </li>
                    <li>
                        <img :src="img6">
                        <input type="file" accept="image/*" name="file_head" @change="imgFun6($event)"/>
                    </li>
                    <li>
                        <img :src="img7">
                        <input type="file" accept="image/*" name="file_head" @change="imgFun7($event)"/>
                    </li>
                    <li>
                        <img :src="img8">
                        <input type="file" accept="image/*" name="file_head" @change="imgFun8($event)"/>
                    </li>
                </div>     
            </ul>

            <p v-if="showAdd" @click="addFun()">
                <span>添加更多图片</span>
                <img src="../../../static/images/shootShop/more.png">
            </p>
        </div>
        <div class="bottomDiv">
            <p>1、请在白天光线好时拍摄，注意店面招牌不要有反光；</p>
            <p>2、请务必横向拍摄；</p> 
            <p>3、尽量拍摄完整的店铺照片，照片中不要有行人和车辆等；</p>
            <p>4、座机示例：01000000000；</p>
            <p>5、为保证定位准确，请开启GPS。</p>
        </div>
        
        <div class="btn" v-if="showBtn">
            <p @click="btnFun()">提交</p>
        </div>

        <div class="btn" v-else>
            <p style="background: #ccc;">提交</p>
        </div>

        <div class="popupWrap" v-if="showPopup">
            <div class="popupBox">
                <h3>提交成功</h3>
                <h5>您可以在“拍店记录”列表中进行查看</h5>
                <router-link to='/record'>
                    <p>查看列表</p>
                </router-link>    
            </div>
        </div>
        <div class="popupWrap" v-if="show401">
            <div class="popupBox">
                <h3><font color="red">提交失败</font></h3>
                <h5>部分图片未提交成功，请刷新页面重新提交</h5>
                <router-link to='/home'>
                    <p>确认</p>
                </router-link>    
            </div>
        </div>

        <div id="allmap"></div>
    </div>
</div>
</template>
<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
import { Toast } from 'mint-ui';
export default {
    name: 'seekShop',
    data () {
        return {

            shopkeeperTel: "", //店主电话
            lngLat: "", //获取经纬度
            addressStr: "", //地理位置

            img1: "../../../static/images/shootShop/img1.png",
            img2: "../../../static/images/shootShop/img2.png",
            img3: "../../../static/images/shootShop/img3.png",
            img4: "../../../static/images/shootShop/img4.png",
            img5: "../../../static/images/shootShop/img5.png",
            img6: "../../../static/images/shootShop/img5.png",
            img7: "../../../static/images/shootShop/img5.png",
            img8: "../../../static/images/shootShop/img5.png",

            fileImgl1: "" ,
            fileImgl2: "" ,
            fileImgl3: "" ,
            fileImgl4: "" ,
            fileImgl5: "" ,
            fileImgl6: "" ,
            fileImgl7: "" ,
            fileImgl8: "" ,

            isUpImg1: 0,
            isUpImg2: 0,
            isUpImg3: 0,
            isUpImg4: 0,
            isUpImg5: 0,

            imgUrl1: "", // 正面照
            imgUrl2: "", // 左侧照
            imgUrl3: "", // 右侧照
            imgUrl4: "", // 电话号码

            isIndex1: "0",
            isIndex2: "0",
            isIndex3: "0",
            isIndex4: "0",

            imgList: [],

            // otherPicArr: [],

            addImgList: [],

            imgsrc: [],

            imgArr: [],

            imgArrString: "",

            imgUrls: "",

            showPopup: false, //弹窗
            show401: false,
            showAdd: true, //查看更多
            showMore: false, //其他图片
            showRepeat: false, //店铺是否重复

            host: "",
            policy: "",
            signature: "",
            accessid: "",
            dir: "",
            expire: "",
            callback: "",

            showBtn: true,

            isbol: "0",
            isbol1: "0",

            jnCityId: "", //济南城市Id
            
            iswx: (function(){return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1})(),
            


        }
    },
    computed:{

    },
    updated(){

    },
    methods:{
    
    		islogin(){
    		// 获取cookie
        function getCookie(sName){
            var aCookie = document.cookie.split("; ");
            for (var i=0; i < aCookie.length; i++){
                var aCrumb = aCookie[i].split("=");
                if (sName == aCrumb[0])
                return unescape(aCrumb[1]);
            }
            return null;
        }
        this.iphoneCookie = getCookie("iphone");
        this.tokenCookie = getCookie("token");

        if(this.iphoneCookie){
            localStorage.iphone = this.iphoneCookie;
            localStorage.token = this.tokenCookie;
        }else{
            localStorage.clear();
        };
         if(!localStorage.iphone){
                //this.$router.push({path:"/login", query:{urlType:"home"}});
                history.pushState("","","/login");
               // go();
               //适配微信浏览器
                window.location.href = location.href+'?time='+((new Date()).getTime());
            }
    	},
		
        addFun(){
            this.showAdd = false;
            this.showMore = true;
        },

        //本地图片预览
        imgFun1(event){
            let _this = this;
            //1. 拿到fileinput里面的文件, 这个file是一个file对象， file对象不能直接展示的
            var file = event.target.files[0];
            this.fileImgl1 = file;
     
            //2. 读取文件，成功img标签可以直接使用的格式
            var reader = new FileReader();
     
            //3. 开始读文件
            reader.readAsDataURL(file);
     
            //4. 因为文件读取是一个耗时操作， 所以它在回调函数中，才能够拿到读取的结果
            reader.onload = function() {
                // console.log(reader.result);
                //直接使用读取的结果
                _this.img1 = reader.result;
                _this.isUpImg1 = "1";
            }
            
        },

        imgFun2(event){
            let _this = this;
            var file = event.target.files[0];
            this.fileImgl2 = file;
            var reader = new FileReader();
       
            reader.readAsDataURL(file);
     
            reader.onload = function() {
                _this.img2 = reader.result;
                _this.isUpImg2 = "1";
            }
        },

        imgFun3(event){
            let _this = this;
            var file = event.target.files[0];
            this.fileImgl3 = file;
            var reader = new FileReader();
       
            reader.readAsDataURL(file);
     
            reader.onload = function() {
                _this.img3 = reader.result;
                _this.isUpImg3 = "1";
            }
        },

        imgFun4(event){
            let _this = this;
            var file = event.target.files[0];
            this.fileImgl4 = file;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function() {
                _this.img4 = reader.result;
                _this.isUpImg4 = "1";
            }
        },

        imgFun5(event){
            let _this = this;
            var file = event.target.files[0];
            this.fileImgl5 = file;
            // this.otherPicArr.push(file);

            this.isbol1 = "1";

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function() {
                _this.img5 = reader.result;
            }
        },

        imgFun6(event){
            let _this = this;
            var file = event.target.files[0];
            this.fileImgl6 = file;

            this.isbol1 = "1";

            // this.otherPicArr.push(file);
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function() {
                _this.img6 = reader.result;
            }
        },

        imgFun7(event){
            let _this = this;
            var file = event.target.files[0];
            this.fileImgl7 = file;
            // this.otherPicArr.push(file);

            this.isbol1 = "1";


            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function() {
                _this.img7 = reader.result;
            }
        },

        imgFun8(event){
            let _this = this;
            var file = event.target.files[0];
            this.fileImgl8 = file;

            this.isbol1 = "1";

            // this.otherPicArr.push(file);
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function() {
                _this.img8 = reader.result;
            }
        },
        
        random_string(len) {
            len = len || 32;
            var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz123456789';
            var maxPos = chars.length;
            var pwd = '';
            for (var i = 0; i < len; i++) {
                pwd += chars.charAt(Math.floor(Math.random() * maxPos));
            }
            return pwd;
        },

        // 点击提交按钮
        btnFun(){

            // var ulLength = $('.uploadPicUl input').length;

            var ulLength = $('.uploadPicUl input').var;

            // console.log(ulLength);


            let _this = this;

            if(this.shopkeeperTel == ""){

                Toast({
                    message: "请输入店主电话",
                    duration: 2000
                });

            }else if(this.showRepeat == true){

                Toast({
                    message: "已有该铺，请重新上传",
                    duration: 2000
                });

            }else if((!( /^(0?(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8})|(400|800)([0-9\\-]{7,10})|(([0-9]{4}|[0-9]{3})(-| )?)?([0-9]{7,8})((-| |转)*([0-9]{1,4}))?$/.test(this.shopkeeperTel)))){

                Toast({
                    message: "电话号码格式不正确",
                    duration: 2000
                });

            }else if(this.isUpImg1 == "0" || this.isUpImg2 == "0" || this.isUpImg3 == "0" || this.isUpImg4 == "0"){

                Toast({
                    message: "请上传前4张图片",
                    duration: 2000
                });

            }else{

                Toast({
                    message: "上传中",
                    duration: 3000
                });

                this.showBtn = false;

                // 正面照
                if(this.isUpImg1 == "1"){
                    var ossData = new FormData();
                    ossData.append('OSSAccessKeyId', _this.accessid);
                    ossData.append('policy', _this.policy);
                    ossData.append('Signature', _this.signature);
                    ossData.append('key', _this.dir + _this.random_string(32));
                    ossData.append('success_action_status', 200); // 指定返回的状态码
                    ossData.append("callback", _this.callback);
                    ossData.append("file", _this.fileImgl1);
                    this.$http.post(this.host, ossData, { headers: { "Content-Type": "multipart/form-data" } })
                    .then(ret => {
                        _this.imgUrl1 =  _this.host + "/" + ret.data.fileName;
                        this.isIndex1 = "1"; 

                        if(this.isbol1 == "0"){
                            if(this.isIndex1 == "1" && this.isIndex2 == "1" && this.isIndex3 == "1" && this.isIndex4 == "1"){
                                _this.upData();
                            }
                        }else{
                            if(this.isIndex1 == "1" && this.isIndex2 == "1" && this.isIndex3 == "1" && this.isIndex4 == "1" && this.isbol == "1"){
                                _this.upData();
                            }
                        }

                    }).catch(err => {
                        console.log(err)
                    });
                }

                // 左侧照
                if(this.isUpImg2 == "1"){
                    var ossData = new FormData();
                    ossData.append('OSSAccessKeyId', _this.accessid);
                    ossData.append('policy', _this.policy);
                    ossData.append('Signature', _this.signature);
                    ossData.append('key', _this.dir + _this.random_string(32));
                    ossData.append('success_action_status', 200); // 指定返回的状态码
                    ossData.append("callback", _this.callback);
                    ossData.append("file", _this.fileImgl2);
                    this.$http.post(this.host, ossData, { headers: { "Content-Type": "multipart/form-data" } })
                    .then(ret => {
                        _this.imgUrl2 =  _this.host + "/" + ret.data.fileName;
                        this.isIndex2 = "1"; 

                         if(this.isbol1 == "0"){
                            if(this.isIndex1 == "1" && this.isIndex2 == "1" && this.isIndex3 == "1" && this.isIndex4 == "1"){
                                _this.upData();
                            }
                        }else{
                            if(this.isIndex1 == "1" && this.isIndex2 == "1" && this.isIndex3 == "1" && this.isIndex4 == "1" && this.isbol == "1"){
                                _this.upData();
                            }
                        }

                    }).catch(err => {
                        console.log(err)
                    });
                }

                // 右侧照
                if(this.isUpImg3 == "1"){
                    var ossData = new FormData();
                    ossData.append('OSSAccessKeyId', _this.accessid);
                    ossData.append('policy', _this.policy);
                    ossData.append('Signature', _this.signature);
                    ossData.append('key', _this.dir + _this.random_string(32));
                    ossData.append('success_action_status', 200); // 指定返回的状态码
                    ossData.append("callback", _this.callback);
                    ossData.append("file", _this.fileImgl3);
                    this.$http.post(this.host, ossData, { headers: { "Content-Type": "multipart/form-data" } })
                    .then(ret => {
                        // console.log(ret);
                        _this.imgUrl3 =  _this.host + "/" + ret.data.fileName;
         
                        this.isIndex3 = "1"; 

                        if(this.isbol1 == "0"){
                            if(this.isIndex1 == "1" && this.isIndex2 == "1" && this.isIndex3 == "1" && this.isIndex4 == "1"){
                                _this.upData();
                            }
                        }else{
                            if(this.isIndex1 == "1" && this.isIndex2 == "1" && this.isIndex3 == "1" && this.isIndex4 == "1" && this.isbol == "3"){
                                _this.upData();
                            }
                        }

                    }).catch(err => {
                        console.log(err)
                    });
                }

                // 电话张贴图
                if(this.isUpImg4 == "1"){
                    var ossData = new FormData();
                    ossData.append('OSSAccessKeyId', _this.accessid);
                    ossData.append('policy', _this.policy);
                    ossData.append('Signature', _this.signature);
                    ossData.append('key', _this.dir + _this.random_string(32));
                    ossData.append('success_action_status', 200); // 指定返回的状态码
                    ossData.append("callback", _this.callback);
                    ossData.append("file", _this.fileImgl4);
                    this.$http.post(this.host, ossData, { headers: { "Content-Type": "multipart/form-data" } })
                    .then(ret => {
                        // console.log(ret);
                        _this.imgUrl4 =  _this.host + "/" + ret.data.fileName;

                        this.isIndex4 = "1"; 

                         if(this.isbol1 == "0"){
                            if(this.isIndex1 == "1" && this.isIndex2 == "1" && this.isIndex3 == "1" && this.isIndex4 == "1"){
                                _this.upData();
                            }
                        }else{
                            if(this.isIndex1 == "1" && this.isIndex2 == "1" && this.isIndex3 == "1" && this.isIndex4 == "1" && this.isbol == "4"){
                                _this.upData();
                            }
                        }

                    }).catch(err => {
                        console.log(err)
                    });
                }

                if(_this.fileImgl5 != ""){
                    this.addImgList.push(this.fileImgl5);
                }
                if(_this.fileImgl6 != ""){
                    this.addImgList.push(_this.fileImgl6);
                }
                if(_this.fileImgl7 != ""){
                    this.addImgList.push(_this.fileImgl7);
                }
                if(_this.fileImgl8 != ""){
                    this.addImgList.push(_this.fileImgl8);
                }


                for (var i = 0; i < this.addImgList.length; i++){
                    var ossData = new FormData();
                    ossData.append('OSSAccessKeyId', _this.accessid);
                    ossData.append('policy', _this.policy);
                    ossData.append('Signature', _this.signature);
                    //上传阿里云需要一个动态的random
                    ossData.append('key', _this.dir + _this.random_string(32));
                    ossData.append('success_action_status', 200); // 指定返回的状态码
                    ossData.append("callback", _this.callback);
                    ossData.append("file", _this.addImgList[i]);
                    this.$http.post(this.host, ossData, { headers: { "Content-Type": "multipart/form-data" } })
                    .then(res => {

                        // console.log(res);

                        //返回地址如果后台没加/,需要加个/
                        _this.imgsrc = _this.host + "/" + res.data.fileName;

                        //把地址添加到数组中
                        _this.imgArr.push(_this.imgsrc);

                        //转化成字符串上传给后台
                        _this.imgArrString = _this.imgArr.join(",");

                        if(this.addImgList.length == _this.imgArr.length){
                            this.isbol = "1";
                            if(this.isIndex1 == "1" && this.isIndex2 == "1" && this.isIndex3 == "1" && this.isIndex4 == "1"){
                                // console.log("完成5")
                                _this.upData();
                            }                            
                        }

                    }).catch(err => {
                        console.log(err)
                    });
                }

            }
        },

        // 点击上传
        upData(){

            let _this = this;
            if(this.imgArrString == ""){
                this.imgUrls = this.imgUrl1 + "," + this.imgUrl2 + "," + this.imgUrl3  + "," + this.imgUrl4;
            }else{
                this.imgUrls = this.imgUrl1 + "," + this.imgUrl2 + "," + this.imgUrl3  + "," + this.imgUrl4 +","+ this.imgArrString;;
            }
           
            let url = this.changeData() + '/photo/auth/savePhotoInfo'

            axios(url,{
                method: 'post',
                params: {
                    phone: _this.shopkeeperTel,  //店主手机号
                    cityId: sessionStorage.cityId, //市id
                    imgs: this.imgUrls, //图片，用逗号拼接
                    address: _this.addressStr, //详细地址
                    location: _this.lngLat //坐标，经纬度用逗号拼接   
                }
            }).then(data => {
                // console.log(data);
                if(data.data.code == "101"){

                    _this.showPopup = true;
                    _this.showBtn = true;
                }
                if(data.data.code == "401"){
	                	_this.show401 = true;
	                	_this.showBtn = true;
                }
            }).catch(err => {
                console.log(err)
            });
        },

        refreshMap(){
            this.cityFun();

            Toast("已刷新");

        },

        //城市定位
        cityFun(){
            let _this = this;
            var map = new BMap.Map("allmap");
            var point = new BMap.Point();
            map.centerAndZoom(point,12);
            var geolocation = new BMap.Geolocation();
            geolocation.getCurrentPosition(function(r){
                if(this.getStatus() == BMAP_STATUS_SUCCESS){
                    var mk = new BMap.Marker(r.point);
                    map.addOverlay(mk);
                    map.panTo(r.point);
                    _this.lngLat = r.point.lng +','+ r.point.lat;
					//alert(_this.lngLat);
                    _this.mapFun(r.point.lng,r.point.lat);
                }
                else {
                    console.log('failed'+this.getStatus());
                }        
            });

        },
        
        mapFun(lng,lat){
            let _this = this;
            var map = new BMap.Map("allmap");
            var point = new BMap.Point(lng,lat);
            var gc = new BMap.Geocoder();
            gc.getLocation(point, function(rs){
               var addComp = rs.addressComponents;
               // console.log(addComp);
               // console.log(addComp.province + "," + addComp.city + "," + addComp.district + "," + addComp.street + "," + addComp.streetNumber);

               _this.addressStr = addComp.district + addComp.street + addComp.streetNumber;

            });
        },

        // 获取OSS
        ossData(){
            axios({
                url: this.changeData() + '/oss/policy',
                method: 'post'
            }).then(res => {
                // console.log(res);
                this.host = res.data.host;
                this.policy = res.data.policy;
                this.signature = res.data.signature;
                this.accessid = res.data.accessid;
                this.dir = res.data.dir;
                this.expire = res.data.expire;
                this.callback = res.data.callback;
            }).catch(err => {
                console.log(err)
            });
        },

    },
    
    mounted() {
    
        let _this = this;

        this.jnCityId = sessionStorage.cityId;

        // 获取OSS
        this.ossData();

        _this.cityFun();
        
        this.islogin();

    },
    
    watch: {
        shopkeeperTel(){
            if(this.shopkeeperTel.length == 11){
                if(!( /^(0?(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8})|(400|800)([0-9\\-]{7,10})|(([0-9]{4}|[0-9]{3})(-| )?)?([0-9]{7,8})((-| |转)*([0-9]{1,4}))?$/.test(this.shopkeeperTel))){ 
                    Toast({
                        message: "电话号码格式不正确",
                        duration: 2000
                    });
                }else{
                    let _this = this;
                    let url = _this.changeData() + '/photo/auth/verifyPhone'
                    axios(url,{
                        method: 'post',
                        params: {
                            phone: this.shopkeeperTel,  //店主手机号
                            cityId: sessionStorage.cityId, //市id
                        }
                    }).then(data => {
                        // console.log(data);
                        if(data.data.code == "101"){
                            if(data.data.flag == false){
                                this.showRepeat = true;
                            }
                        }else if(data.data.code == "201"){
                        		Toast({
                                message: "未登录，请登录后操作",
                                duration: 2000
                            });
                        }else{
                            Toast({
                                message: "系统繁忙，请稍后重试",
                                duration: 2000
                            });
                        }
                    }).catch(err => {
                        console.log(err)
                    });

                }
            }else{
                this.showRepeat = false;
            }


        }
    }
}
</script>

<style scoped lang="scss">
/*浮动*/
.pull-right{
    float: right;
}
.pull-left{
    float: left;
}
.clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
}
.clearfix {
    zoom: 1;
}

input::-webkit-input-placeholder{
    color: #9f9fa8;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color: #9f9fa8;
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color: #9f9fa8;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color: #9f9fa8;
}
/*内容部分*/
.makeMoney{
    width: 7.5rem;
    margin: 0 auto;
}
.nav{
    width: 6.9rem;
    height: .88rem;
    background: #fff;
    margin: 0 auto;
    padding:  0 0.3rem;
    position: fixed;
    top: 0;
    z-index: 9;
    a{
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
    .navBack{
        width: 0.2rem;
        height: 0.36rem;
        margin-top: 0.26rem;
    }
    .navTitle{
        width: 6.4rem;
        line-height: .9rem;
        font-size: 0.36rem;
        color: #3c3c3c;
        text-align: center;
    }
    .record{
        color: #666666;
        font-size: .28rem;
        position: absolute;
        right: .3rem;
        top: .24rem;
    }
}
.makeMoney-center{
    width: 6.9rem;
    margin: 1.2rem .3rem 0;
    .imgBanner{
        width: 6.9rem;
        height: 2rem;
        img{
            width: 6.9rem;
            height: 2rem;
        }
    }
    .makeMoney-center-Dl{
        width: 6.3rem;
        padding: 0 .3rem;
        margin: .2rem 0;
        background: #fff;
        border-radius: 10px;
        dl{
            width: 6.3rem;
            padding: .4rem 0;
            dt{
                float: left;
                span{
                    color: #363636;
                    font-size: .3rem; 
                    margin-left: .1rem;
                }
                img{
                    position: relative;
                    top: -.03rem;
                    left: 0px;
                }
            }
            dd{
                float: right;
            }
        }
        .dl1{
            border-bottom: .02rem solid #f2f5f6;
            position: relative;
            dt{
                img{
                    width: .3rem;
                    height: .3rem;
                }
            }
            dd{
                input{
                    width: 1.94rem;
                    color: #363636;
                    font-size: .28rem;
                    text-align: right;
                }
            }
            div{
                height: .21rem;
                position: absolute;
                right: 0;
                bottom: .26rem;
                img{
                    width: .2rem;
                    height: .2rem;
                }
                span{
                    font-size: .2rem;
                    color: #e62303
                }
            }
        }
        .dl2{
            dt{
                img{
                    width: .28rem;
                    height: .34rem;
                }
            }
            dd{
                span{
                    font-size: .28rem;
                    color: #363636;
                    margin-right: .1rem;
                }
                img{
                    width: .26rem;
                    height: .3rem;
                    position: relative;
                    top: -.04rem;
                    left: 0px;
                }
            }

        }
    }
}
.uploadPic{
    width: 6.3rem;
    padding: 0 .3rem;
    margin: 0 auto;
    background: #fff;
    border-radius: 10px;
    dl{
        padding: .4rem 0;
        dt{
            float: left;
            color: #363636;
            font-size: .3rem;
        }
        dd{
            float: right;
            span{
                color: #666;
                font-size: .28rem;
                margin-right: .06rem;
            }
            img{
                width: .3rem;
                height: .3rem;
                position: relative;
                top: -.02rem;
                left: 0px;
            }
        }
    }
    ul{
        li{
            width: 3.05rem;
            height: 2.05rem;
            margin-bottom: .2rem; 
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            position: relative;
            img{
                width: 3.05rem;
                height: 2.05rem;
                -webkit-tap-highlight-color: rgba(0,0,0,0);
            }
            input{
                -webkit-tap-highlight-color: rgba(0,0,0,0);
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0px;
                top: 0px;     
                opacity: 0;   
                img{
                    width: 3.16rem;
                    height: 2.37rem;
                }
            }

        }
        li:nth-child(odd){
            float: left;
        }
        li:nth-child(even){
            float: right;
        }
    }
    p{
        height: .9rem;
        width: 6.3rem;
        border-top: 1px solid #f2f5f6;
        line-height: .9rem;
        text-align: center;
        color: #666;
        font-size: .28rem;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        img{
            width: .26rem;
            height: .14rem;
        }
    }
}
.bottomDiv{
    width: 6.9rem;
    margin: .2rem auto;
    padding-bottom: .8rem;
    p{
        color: #9f9fa8;
        font-size: .24rem;
        line-height: .34rem;
    }
}
.btn{
    width: 7.5rem;
    height: .88rem;
    background: #fff;
    padding: .2rem 0;
    position: fixed;
    bottom: 0px;
    left: auto;
    p{
        width: 6.6rem;
        height: .88rem;
        text-align: center;
        line-height: .88rem;
        color: #fff;
        font-size: .32rem;
        background: #2f7af7;
        border-radius: 44px;
        margin: 0 auto;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
}
#allmap{
    width: 10px;
    height: 10px;
    position: absolute;
    left: 0;
    top: 0;
}

/* 弹窗 */
.popupWrap{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    position: fixed;
    left: auto;
    top: 0;
    z-index: 999;
    .popupBox{
        width: 4.8rem;
        height: 2.52rem;
        background: #fff;
        border-radius: 16px;
        padding: .5rem;
        position: absolute;
        top: 35%;
        left: 50%;
        margin-left: -2.9rem;
        h3{
            color: #333;
            font-size: .4rem;
            font-weight: 500;
            text-align: center;
        }
        h5{
            color: #666;
            font-size: .26rem;
            font-weight: 400;
            text-align: center;
            margin: .2rem 0 .4rem;
        }
        p{
            color: #fff;
            width: 4.8rem;
            background: #2f7af7;
            line-height: .82rem;
            text-align: center;
            font-size: .28rem;
            border-radius: 40px;
            font-weight: 500;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
        }
    }

}

</style>



// WEBPACK FOOTER //
// src/components/shootShop/makeMoney.vue